import { render } from "./PartnerProperty.vue?vue&type=template&id=27375d56&scoped=true&ts=true"
import script from "./PartnerProperty.vue?vue&type=script&lang=ts"
export * from "./PartnerProperty.vue?vue&type=script&lang=ts"

import "./PartnerProperty.vue?vue&type=style&index=0&id=27375d56&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27375d56"]])

export default __exports__